import styled from 'styled-components';
import { animated } from 'react-spring';
import { ArrowIcon } from '../Icons';
import { Button } from '../Button';
import { TextHint } from '../Hint';

export const CircleWrapper = styled(Button)`
  cursor: pointer;
  padding: 5px 0px;
  height: auto;
  width: 20px;
  margin-right: 2px;
  &:hover{
    background-color: transparent;    
  }

  ${(props) => ({
    display: props.isBolded ? 'none' : '',
  })}
`;
export const Container = styled.div`
  background-color: ${(props) => props.theme.colors.UploadSurveyInputColor};
  border-radius: 10px;
  text-transform: uppercase;
  color: #6C6C6C;
  font-size: 1.2rem;
  line-height: 14px;
  width: 100%;

  ${(props) => ({
    backgroundColor: props.isChecked || !props.isCollapsed ? props.theme.colors.UploadSurveyBackgroundActiveItem : 'transparent',
  })}
  
  &:focus-within{
    ${CircleWrapper}{
      ${(props) => ({
    padding: props.highlightFocusItem ? '3px' : '5px 0',
  })}            
    }
  }
`;

export const Circle = styled.span`
  width: 11px;
  height: 11px;
  border-radius: 2px;
  border: 1px solid #00bec1;
  display: inline-block;
  margin-right: 5px;
  background: ${(props) => (props.isChecked ? props.theme.colors.radioButtonColor : "none")};
  box-sizing: border-box;
  position: relative;

  ${({ isChecked }) =>
    isChecked
      ? `
    :before,
  :after {
    content: "";
    position: absolute;
    display: block;
    height: 6px;
    width: 1.5px;
    background: #0a6264;
  }

  :after {
    transform: rotate(45deg);
    left: 4.4px;
    top: 1.7px;
  }
  :before {
    height: 2px;
    transform: rotate(-45deg);
    left: 1.7px;
    top: 4.2px;
  }
  `
      : ""}
`;

export const CircleItem = styled.span`
  width: 11px;
  height: 11px;
  border-radius: 11px;
  border: 1px solid #00bec1;
  display: inline-block;
  margin-right: 5px;
  background: none;
  box-sizing: border-box;
  padding: 1px;

  :after {
    content: "";
    display: block;
    border-radius: 7px;
    width: 7px;
    height: 7px;
    background: ${(props) => (props.isChecked ? props.theme.colors.radioButtonColor : "transparent")};
  }
`;

export const Arrow = styled(ArrowIcon)`
  vertical-align: bottom;
  overflow: hidden;

  ${(props) => ({
    color: props.isChecked ? props.theme.colors.ArrowIconCheckColor : props.theme.colors.ArrowIconUncheckColor,
  })}
`;

export const Head = styled.div`
  padding: ${(props) => (props.textPadding ? props.textPadding : '5px 20px 7px 8px')};
  cursor: pointer;
  display: flex;
  align-items: center;
  height: 35px;
  border-bottom: ${(props) => (!props.isCollapsed ? `1px solid ${props.theme.colors.headerConfigLine}` : 'none')};
  &:hover {
    background: ${(props) => props.theme.collapsibleList.itemHoverBackground};
    border-radius: 10px;
  }
`;

export const Collapser = styled(Button)`
  cursor: pointer;
  padding: 5px 0px;
  height: auto;
  overflow: hidden;
  align-items: center;
  display: inline-flex;
  color: inherit;
  max-width: 95%;
  @media (max-width: 586px) {
    max-width: 88%;
  }
  &:hover{
    background-color: transparent;
  }
`;

export const Text = styled.span`
  overflow: hidden;
  white-space:nowrap;
  text-overflow:ellipsis;
  display:inline-block;
  width: 85%;
  flex: 1;
  color: ${(props) => props.theme.collapsibleList.textColor};
`;

export const Title = styled(Text)`
text-transform: ${(props) => (props.isUpperCase ? 'uppercase' : 'initial')};
  ${(props) => ({
    color: props.isBolded ? props.theme.collapsibleList.titleColorBolded : props.theme.collapsibleList.titleColorUnBolded,
    fontWeight: props.isBolded ? 'bold' : 'inherit',
  })}
`;

export const TextWithHint = styled(TextHint)`
  ${(props) => ({
    color: props.isBolded ? '#610082' : 'inherit',
    fontWeight: props.isBolded ? 'bold' : 'inherit',
  })}
  overflow: hidden;
  white-space:nowrap;
  text-overflow:ellipsis;
  display:inline-block;
  width: 85%;
  flex: 1;
`;

export const Body = styled(animated.div)`
  overflow: hidden;
  padding: 0px 20px;
  padding-bottom: 5px;
  height: 100% !important;
`;

export const Items = styled.div`
  padding: 15px 20px 5px;
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  width: 100%;
`;

export const ItemsEmpty = styled.div`
  padding: 0px 24px;
  align-items: center;
  display: flex;
  justify-content: center;
  width: 100%;
  height: 100px;
`;

export const Item = styled(Button)`
  cursor: pointer;
  width: calc(100% / 3);
  padding: 7px 35px;
  overflow: hidden;
  align-items: baseline;
  display: flex;
  color: inherit;
  height: auto;
  text-align: start;
`;

export const FixedItem = styled.div`
  width: calc(100% / 3);
  padding: 7px 7px;
  overflow: hidden;
  align-items: baseline;
  display: flex;
  color: inherit;
  height: auto;
  text-align: start;
`;
